import React from 'react';
import styled from 'styled-components';

import { BrowserRouter as Router, browserHistory, Switch, Route, Link } from "react-router-dom";
import { Button, Form } from 'semantic-ui-react'
import Content from '../content'
import Formmessage from '../content/message'
// import './App.css';
import { Titletext, Appmain, Unitfull, Unit, Unitsblock, Unittext, UnittextOp } from './small-style';
// import {Destselect, options, Formmessage } from './App-message'
// import { slide as Menu } from 'react-burger-menu'

const Smalldraw = props => {

  const {titleunits, winwidth, winheight, anim, extrasmall} = props

  return (
          <div>

                {titleunits.map((unit)=>
                  <Route path={"/"+unit.id+"/"} render={()=>
                                          <Unitfull winwidth={winwidth} winheight={winheight} bool={anim} >
                                          <Formmessage/>
                                                   <div className='contentheader'>
                                                   <div>
                                                       &nbsp;
                                                   </div>
                                                   <div className='contentheaderlink'>
                                                                 <Link to="/" >(Закрыть)</Link>
                                                   </div>


                                                   </div>
                                                   <Content extrasmall={true} unit={unit.id} />
                                           </Unitfull>
                                            } />
                )}

                {extrasmall ?


                    <Titletext extrasmall={extrasmall} winwidth={winwidth}>Тульский областной центр новых информационных технологий является структурным подразделением государственного образовательного учреждения высшего профессионального образования <br /> "Тульский государственный университет" (ТулГУ)</Titletext>


                :
                <Route exact path={"/"} render={()=>
                      <Unitsblock extrasmall={extrasmall}>

                              {titleunits.map((text, index) => (
                              <Unit winwidth={winwidth} winheight={winheight} id={text.id}  extrasmall={extrasmall} >


                                  <Link to={'/'+text.id+'/'} >
                                    <div  style={{'cursor':'pointer'}}>
                                            <Unittext winwidth={winwidth}>{text.unitname} </Unittext>
                                    </div>
                                  </Link>

                                </Unit>



                              ))}
                      </Unitsblock>
                 } />

              }


      </div>
)}

export default Smalldraw
